import './styles/LabeledInput.scss';

import clsx from 'clsx';
import { FunctionComponent, ReactNode } from 'react';

interface Props {
  label: string;
  displayAlways?: boolean;
  wrap?: boolean;
  noEllipsis?: boolean;
  style?: React.CSSProperties;
  children?: ReactNode;
}

export const LabeledInput: FunctionComponent<Props> = props => {
  return props.displayAlways || props.children ? (
    <div className="labeled-input">
      <span
        className={clsx('labeled-input__label', {
          'labeled-input__label--wrap': props.wrap
        })}
        style={props.style}
      >
        {props.label}
      </span>
      <span title={typeof props.children !== 'object' ? (props.children as string) : ''}>
        {props.children || (!props.noEllipsis && '-------')}
      </span>
    </div>
  ) : null;
};
